import React, { useState, useEffect } from 'react';
import { User, Lock, Phone, Save, Eye, EyeOff, CheckCircle } from 'lucide-react';
import '../../styles/sidebar/Settings.css';

const API = process.env.REACT_APP_API_URL || 'https://api.anti-bot.ai';

export default function Settings() {
  const [username, setUsername]         = useState('');
  const [newUsername, setNewUsername]   = useState('');
  const [newPassword, setNewPassword]   = useState('');
  const [confirmPass, setConfirmPass]   = useState('');
  const [phone, setPhone]               = useState('');
  const [showPass, setShowPass]         = useState(false);
  const [showConfirm, setShowConfirm]   = useState(false);
  const [loading, setLoading]           = useState(false);
  const [success, setSuccess]           = useState('');
  const [error, setError]               = useState('');

  useEffect(() => {
    const u = localStorage.getItem('ab_username') || '';
    const p = localStorage.getItem('ab_phone') || '';
    setUsername(u);
    setNewUsername(u);
    setPhone(p);
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword && newPassword !== confirmPass) {
      setError('הסיסמאות אינן תואמות');
      return;
    }
    if (newPassword && newPassword.length < 6) {
      setError('הסיסמה חייבת להכיל לפחות 6 תווים');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          current_username: username,
          new_username: newUsername !== username ? newUsername : '',
          new_password: newPassword,
          phone,
        }),
      });
      const data = await res.json();
      if (data.success) {
        const finalUsername = data.new_username || username;
        localStorage.setItem('ab_username', finalUsername);
        localStorage.setItem('ab_phone', phone);
        setUsername(finalUsername);
        setNewUsername(finalUsername);
        setNewPassword('');
        setConfirmPass('');
        setSuccess('ההגדרות נשמרו בהצלחה');
      } else {
        setError(data.error || 'שגיאה בשמירה');
      }
    } catch {
      setError('שגיאת חיבור לשרת');
    }
    setLoading(false);
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h2 className="settings-title">הגדרות חשבון</h2>
        <p className="settings-subtitle">עדכן את פרטי החשבון שלך</p>
      </div>

      <form className="settings-form" onSubmit={handleSave}>

        {/* שם משתמש */}
        <div className="settings-section">
          <h3 className="settings-section-title">פרטי חשבון</h3>

          <div className="settings-field">
            <label className="settings-label">שם משתמש</label>
            <div className="settings-input-wrap">
              <User size={16} className="settings-input-icon" />
              <input
                className="settings-input"
                value={newUsername}
                onChange={e => setNewUsername(e.target.value)}
                placeholder="שם משתמש חדש"
                autoComplete="username"
              />
            </div>
          </div>

          <div className="settings-field">
            <label className="settings-label">סיסמה חדשה</label>
            <div className="settings-input-wrap">
              <Lock size={16} className="settings-input-icon" />
              <input
                className="settings-input"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="השאר ריק כדי לא לשנות"
                type={showPass ? 'text' : 'password'}
                autoComplete="new-password"
              />
              <button type="button" className="settings-eye" onClick={() => setShowPass(v => !v)}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <div className="settings-field">
            <label className="settings-label">אימות סיסמה</label>
            <div className="settings-input-wrap">
              <Lock size={16} className="settings-input-icon" />
              <input
                className="settings-input"
                value={confirmPass}
                onChange={e => setConfirmPass(e.target.value)}
                placeholder="הכנס שוב את הסיסמה החדשה"
                type={showConfirm ? 'text' : 'password'}
                autoComplete="new-password"
              />
              <button type="button" className="settings-eye" onClick={() => setShowConfirm(v => !v)}>
                {showConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
        </div>

        {/* התראות SMS */}
        <div className="settings-section">
          <h3 className="settings-section-title">התראות SMS</h3>
          <p className="settings-section-desc">קבל הודעת SMS כאשר מזוהה בוט חדש</p>

          <div className="settings-field">
            <label className="settings-label">מספר טלפון</label>
            <div className="settings-input-wrap">
              <Phone size={16} className="settings-input-icon" />
              <input
                className="settings-input"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                placeholder="+972501234567"
                type="tel"
                dir="ltr"
              />
            </div>
          </div>
        </div>

        {error   && <div className="settings-error">{error}</div>}
        {success && (
          <div className="settings-success">
            <CheckCircle size={16} />
            {success}
          </div>
        )}

        <button className="settings-save-btn" type="submit" disabled={loading}>
          <Save size={16} />
          {loading ? 'שומר...' : 'שמור שינויים'}
        </button>

      </form>
    </div>
  );
}
